import { ChangeEvent, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useSearchParams } from "../../../../../hooks/useSearchParams";
import { Box, Tab } from "@material-ui/core";
import { Tabs } from "@material-ui/core";
import PeopleAlt from "@material-ui/icons/PeopleAlt";
import ApartmentIcon from "@material-ui/icons/Apartment";
import { useUsersDetailsTabsStyles } from "./styles";
import { UserInScheduleWithPermissions } from "../../../../../interfaces/user";
import ProfileTab from "./components/profile-tab";
import LinkedOrgans from "./components/linked-organs";

type Props = {
  user: UserInScheduleWithPermissions;
}

export default function UsersDetailsTabs({ user }: Props) {
  const { classes } = useUsersDetailsTabsStyles();
  const { pathname } = useLocation();
  const searchParams = useSearchParams();
  const history = useHistory();

  const value = useMemo(() => {
    const tab = Number(searchParams.get("active_tab"));
    if (isNaN(tab) || tab < 0 || tab > 3) {
      return 0;
    }
    return tab;
  }, [searchParams]);

  const handleChange = (event: ChangeEvent<{}>, newValue: number) => {
    history.replace(`${pathname}?active_tab=${newValue}`);
  };

  return (
    <Box>
      <Tabs
        value={value}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleChange}
        aria-label="disabled tabs"
      >
        <Tab
          label="Perfil"
          icon={<PeopleAlt />}
          classes={{ root: classes.tabRoot }}
        />
        <Tab
          label="Órgãos vinculados"
          icon={<ApartmentIcon />}
          classes={{ root: classes.tabRoot }}
        />
      </Tabs>
      {value === 0 && <ProfileTab user={user} />}
      {value === 1 && <LinkedOrgans organs={user.orgaos} userPermissions={user.permissions} />}
    </Box>
  );
}
